import {
    Box,
    Button,
    Dialog,
    Theme,
    Typography
} from "@mui/material";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import {
    resendOtp,
    validateOtp
} from "../../redux-store/actions/cart";
import {
    ResendOtpResponseBody,
    ValidateOtpResponseBody
} from "../../redux-store/types/cart";
import { useState } from "react";
import { showError } from "../../redux-store/actions/auth";
import { SuccessIcon } from "../../assets/SvgIcons";
import OTPForm from "../../lib/formik/OtpForm";

interface RouterStateData {
    token: string;
    cartId: string;
    id: number | string;
    otpMessage: string;
}

export default function VerifyCartOtp(): JSX.Element {
    const dispatch = useDispatch()
    const history = useHistory();

    const [routerStateObj, setRouterStateObj] = useState<RouterStateData>(history.location.state as RouterStateData)
    const [paymentNotRequired, setPaymentNotRequired] = useState<boolean>(false);
    const [paymentFalseMessage, setPaymentFalseMessage] = useState<string>('');

    const handleSubmit = async (otp: string) => {
        const payload = {
            otp,
            token: routerStateObj?.token ?? "",
            id: routerStateObj?.id ? `${routerStateObj?.id}` : "",
            cartId: routerStateObj?.cartId ?? ""
        }

        const response = await (dispatch(validateOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>)

        if (response?.isSuccess) {
            if (response?.paymentRequired) {
                history.replace('/cart/payment', {
                    cartId: response?.cartId ?? "",
                    token: response?.token ?? ""
                })
            }
            else {
                setPaymentFalseMessage(response?.message ?? "");
                setPaymentNotRequired(true);
            }

        }
        if (!response?.isSuccess) {
            dispatch(showError(response?.message ?? ""))
        }
    }

    const handleResend = async () => {
        const payload = {
            cartId: routerStateObj?.cartId ?? "",
            id: routerStateObj?.id ? `${routerStateObj?.id}` : "",
            token: routerStateObj?.token ?? ""
        }

        const response = await (dispatch(resendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            setRouterStateObj({
                token: response?.token ?? "",
                cartId: response?.cartId ?? "",
                id: response?.id ?? "",
                otpMessage: response?.message ?? ""
            })
        }
    }

    const handlePaymentFalsePopup = () => {
        setPaymentNotRequired(false);
        history.replace('/investor-dashboard');
    }

    return (
        <>
            <Box>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Transaction Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <Box sx={{ minWidth: "350px", maxWidth: "500px" }}>
                        <OTPForm
                            onSubmit={handleSubmit}
                            onResend={handleResend}
                            otpMessage={routerStateObj?.otpMessage ?? ""}
                            warningMessage=""
                        />
                    </Box>
                </Box>
            </Box>
            <Dialog
                onClose={() => setPaymentNotRequired(false)}
                open={paymentNotRequired}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={handlePaymentFalsePopup}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}